<eventlyte-registration-analytics-code
	metaPixelId="2020032945247981"
	metaEventName="PageView"
	metaLocale="en_US"
	googleMeasurementId="GTM-W776ZJC7"
	[trackOnRouteChange]="true">
</eventlyte-registration-analytics-code>

<ng-container *transloco="let t">
	<div data-theme="dark">
		<div
			class="header-container is-flex is-justify-content-space-between is-align-items-center">
			<a href="http://aipluspower.com" target="_blank">
				<img src="/images/aipower-logo.png" class="ml-5" />
			</a>

			<eventlyte-registration-language-selector class="mr-5" />
		</div>

		<div
			class="registration-page-container"
			[class.pl-4]="!isLandingPage()"
			[class.pr-4]="!isLandingPage()">
			@if (!isLandingPage()) {
				<div class="title is-3 m-0 p-0 mt-5">{{ t('content.registrationTitle') }}</div>

				<div class="title is-6 mt-2 mb-5">
					{{ t('content.registrationSubtitle') }}
				</div>
				<div style="height: 20px" class="is-hidden-print">&nbsp;</div>
			}

			<div>
				<router-outlet />
			</div>

			<div style="height: 100px" class="is-hidden-print">&nbsp;</div>
		</div>
	</div>
</ng-container>
